import { UIViewController, UITableView, UITableViewDatasource, UITableViewDelegate, UITableViewCell } from "uikit";
import { IndexPath } from "foundation"
import { DLDB, CartLine, Cart } from "dldb"
import { BookingProductCell, BookingProductCellDelegate } from "./BookingProductCell";

export class BookingExtrasViewController extends UIViewController implements UITableViewDatasource, BookingProductCellDelegate
{
    private tableView: UITableView;

    private cart:Cart = DLDB.shared.cart();

    viewDidLoad() {
        super.viewDidLoad();

        this.tableView.dataSource = this;

        this.tableView.reloadData();
    }

        viewWillAppear(animated: boolean): void {
        super.viewWillAppear(animated);
        this.cart.addObserver ( this, "lines", null );
    }

    viewWillDisappear(animated: boolean): void {
        super.viewWillDisappear(animated);
        this.cart.removeObserver ( this, "lines" );
    }

    observeValueForKeyPath(keyPath: string, type: string, object: any, context: any): void {
        if ( keyPath === "lines" && type == "did") this.tableView.reloadData();
    }


    numberOfSections ( tableView: UITableView ) { 
        return 1;
    }

    numberOfRowsInSection(tableView: UITableView, section: number): number {        
        return DLDB.shared.cart().recommendProducts.length;
    }    

    cellForRowAt(tableView: UITableView, indexPath: IndexPath): UITableViewCell
    {
        let cell = tableView.dequeueReusableCellWithIdentifier( "ProductCell" ) as BookingProductCell;
        const line = DLDB.shared.cart().recommendProducts[ indexPath.row ];
        cell.line = line;
        // cell.product = product;
        cell.delegate = this;
        return cell;
    }
    
    onNumProductDidChange(cell: BookingProductCell, product: any, quantity: number): void {        
        DLDB.shared.cart().updateProductQuantity( product["ID"], product["Name"], product["Price"], quantity, [] );
    }
}